import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'ppw-timesheets-not-invoice-dialog',
    templateUrl: './timesheets-not-invoice-dialog.component.html',
    styleUrls: ['./timesheets-not-invoice-dialog.component.scss']
})
export class TimesheetsNotInvoiceDialogComponent {
    constructor(private readonly dialogRef: MatDialogRef<TimesheetsNotInvoiceDialogComponent>) {}

    confirm(): void {
        this.dialogRef.close(true)
    }
}
